export default {
  auth: {
    loading: false,
    data: null,
    error: null,
  },
}